<template>
	<div class="app">
	  <keep-alive>
				<router-view  :key="$route.fullPath"  v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view  :key="$route.fullPath"  v-if="!$route.meta.keepAlive"></router-view>
		<v-tab-bar  v-if="$route.meta.isshowtabbar" ref='bar'></v-tab-bar>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import tabBar from './components/common/Tabbar'
import { cartQuantity } from './api/cart'
import { Toast,Indicator } from 'mint-ui'
export default {
	name: 'app',
	computed: {
		...mapState({
			isOnline: state => state.auth.isOnline
		})
	},
	created: function() {
		if (this.isOnline) {
			this.getCartNumber();
		}		
		this.saveAuthInfo()	
		let name = this.$route.name
		if (name) {
			this.changeTabBar(name);			
		}
	},
	watch: {
		$route(to, from) {
			this.resetStates();
			// this.addView();
			this.changeTabBar(to.name);
		}
	},
	methods: {
		...mapMutations({
			saveToken: 'saveToken',
			clearToken: 'clearToken',
			changeTabBar: 'changeTabBar',
			setCartNumber: 'setCartNumber'
		}),
		...mapActions({
			resetStates: 'resetStates',
			addVisitedViews:'addVisitedViews',
		}),
		generateRoute() {
			if (this.$route.name) {
				return this.$route
			}
			return false
		},
		addView(){
			const route = this.generateRoute()
			if (!route) {
				return false
			}
			this.addVisitedViews(route)
		},
		goBack () {
			window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
		},
		getCartNumber() {
			cartQuantity().then( res => {
				if (res) {
					this.setCartNumber(res.quantity);
				}
			})
		},
		saveAuthInfo() {
			let location = window.location
			let references = this.utils.getUrlKey(location.href, 'u')		
			if (references) {
				this.$cookie.set('r', references)
			}	
			let token = this.utils.getUrlKey(location.href, 'token')		
			if (token) {
				this.$cookie.set('t', token)				
				this.saveToken({ 'token': token })				
			}			
		},				
	},
	components: {
		'v-tab-bar': tabBar
	}
}
</script>

<style lang="scss" scoped>
.app {
	min-height: 100%;
	width:100%;
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue